import { Link } from "react-router-dom";

import Logo from '../assets/images/Logos/kole-medical-emblem.svg';
import LogoTitle from '../assets/images/Logos/kole-medical-wordmark.svg';
import Mail from '../assets/images/icons/mail_100dp_FFFFFF_FILL1_wght400_GRAD0_opsz48.png';
import Phone from '../assets/images/icons/phone_in_talk_100dp_FFFFFF_FILL1_wght400_GRAD0_opsz48.png';
import TikTok from '../assets/images/social-icons/tik-tok-icon.png';
import WhatsApp from '../assets/images/social-icons/whatsapp-icon-noBackground.png';
import '../styles/Footer.css';

const Footer = () => {
    return(
        <footer className="footerContainer">
            <div className="km-container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo">
                            <img src={Logo} alt="" width={48} height={48} />
                            <img className="footer-wordmark" src={LogoTitle} alt="Kole Medical: Chosen for Excellence" width={190} height={37} />
                        </Link>
                        <p className="footer-tagline">Healthcare consultancy specialising in SAHPRA licensing.</p>
                        <a className="footer-contact" href="mailto:info@kolemedical.co.za">
                            <img src={Mail} alt="" />
                            info@kolemedical.co.za
                        </a>
                        <a className="footer-contact" href="tel:+27645406751">
                            <img src={Phone} alt="" />
                            +27 64 540 6751
                        </a>
                    </div>
                    <nav className="footer-column" aria-label="Explore">
                        <h3>Explore</h3>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/service">Services</Link></li>
                            <li><Link to="/events">Webinars &amp; Workshops</Link></li>
                            <li><Link to="/news">News</Link></li>
                            <li><Link to="/quote">Request a Quote</Link></li>
                        </ul>
                    </nav>
                    <nav className="footer-column" aria-label="Support">
                        <h3>Support</h3>
                        <ul>
                            <li><Link to="/query">Contact Us</Link></li>
                            <li><Link to="/service#faq">FAQ</Link></li>
                            <li><Link to="/service#how-it-works">How It Works</Link></li>
                        </ul>
                    </nav>
                    <div className="footer-column">
                        <h3>Follow Us</h3>
                        <ul className="footer-socials">
                            <li>
                                <a href="https://www.tiktok.com/@kolemedical" target="_blank" rel="noreferrer" aria-label="Kole Medical on TikTok">
                                    <img src={TikTok} alt="" />
                                </a>
                            </li>
                            <li>
                                <a href="https://wa.me/27645406751" target="_blank" rel="noreferrer" aria-label="Chat with Kole Medical on WhatsApp">
                                    <img src={WhatsApp} alt="" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2026 KOLE MEDICAL (PTY) LTD. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
